<template>
   <el-container class="content" style="display: block;">
     <div >
       <img @click="goHome()"  :src="require('@/assets/image/goback.png')" style="position: absolute;left: 0;top: 0;z-index: 1008;opacity: 0.8;" :style="{'height':screenHeight*0.03+'px'}" >
     </div>
     <div class="shop1_search" :style="{'width':screenWidth*0.2+'px','left':screenWidth*0.35+'px'}">
     	<input class="shop1_searchi" v-model="search" @keydown.enter="loadList()" style="width: 100%;height: 99%;" />

     	<button class="shop1_searcht"  @click="loadList()"  >搜索</button>

     </div>
     <div style="position: fixed;z-index: 1005;background-color: #000;z-index: 1005;bottom: 0;"  :style="{'width':screenHeight*0.5+'px','height':screenHeight*0.3+'px','right':(screenWidth-screenHeight*0.5)/2+'px'}" >
       <video width="100%" height="100%" ref="videoPlayer" @ended="restartVideo" controls controlslist="nodownload noplaybackrate" disablePictureInPicture="true" id="myVideo1" v-if="ishows">
         <source :src="index_url" type="video/mp4">

       </video>
     </div>
     <div :style="{'width':screenWidth+'px','height':screenHeight+'px'}" style="display: flex;flex-wrap: wrap;background-color: #000;overflow-y: scroll;">

       <!-- <img :src="video['img']"  :width="vwidth" :height="vwidth" @click="open(video['url'])"> -->
      <div v-for="(video, index) in list" :key="index" style="overflow: hidden;">


        <div class="donghuap" v-if="video['cc'] == 1" :style="{'width':vwidth+'px','height':vwidth+'px'}" style="overflow: hidden;">

          <div @click="toPage(video['b_id'])"  :style="{'background-image':`url(${video['bkg']})`}">

            <video v-if="video['v_url'] != '无'" autoplay loop muted playsinline style="object-fit: contain;" :style="{'width': vwidth+'px','height': vwidth+'px'}">
              <source :src="video['v_url']" type="video/mp4" />
            </video>
            <img v-else :src="video['url']"  :width="vwidth" :height="vwidth" style="object-fit: contain;">
          </div>
          <!-- :class="{ddonghua:(video['typed'] == 1),edonghua:(video['typeb'] == 1),adonghua:(video['typea'] == 2)}" -->
          <div  class="donghuai ddonghua" @click="toPage(video['b_id'])"  :style="{'width':vwidth+'px','height':vwidth+'px','margin-left':'-'+vwidth+'px'}" style="color: #ffffff;text-align: center;" >

            <!-- <div :style="{'margin-top':vwidth*0.88+'px'}" style="background-color: #000;height: 20px;line-height: 20px;white-space: nowrap;overflow: hidden;">{{video['ci']}}</div> -->
            <div class="shop2_wenzi" :style="{'margin-top':vwidth*0.75+'px','width':vwidth+'px','height':vwidth*0.25+'px','line-height':vwidth*0.25+'px'}" style="white-space: nowrap;overflow: hidden;">{{video['ci']}}</div>
          </div>



        </div>

        <div class="donghuap" v-if="video['cc'] == 0" :style="{'width':vwidth+'px','height':vwidth+'px'}" style="overflow: hidden;">
         <!-- <div   class="donghuai" :class="{ddonghua:(video['typed'] == 0),edonghua:(video['typec'] == 1),adonghua:(video['typea'] == 1)}" :style="{'background-image':`url(${video['bkg']})`}">
            <img :src="video['url']"  :width="vwidth" :height="vwidth" style="object-fit: contain;">
          </div>

          <div :class="{ddonghua:(video['typed'] == 1),edonghua:(video['typeb'] == 1),adonghua:(video['typea'] == 2)}" class="donghuai"   :style="{'width':vwidth+'px','height':vwidth+'px','line-height':vwidth+'px','margin-left':'-'+vwidth+'px'}" style="color: #ffffff;text-align: center;" >{{video['ci']}}</div>
        -->

          <div  :style="{'background-image':`url(${video['bkg']})`}">
            <img :src="video['url']"  :width="vwidth" :height="vwidth" style="object-fit: contain;">
          </div>

          <div :class="{ddonghua:(video['typed'] == 1),edonghua:(video['typeb'] == 1),adonghua:(video['typea'] == 2)}" class="donghuai"   :style="{'width':vwidth+'px','height':vwidth+'px','margin-left':'-'+vwidth+'px'}" style="color: #ffffff;text-align: center;" >

            <!-- <div :style="{'margin-top':vwidth*0.8+'px'}" style="background-color: #000;height: 20px;line-height: 20px;white-space: nowrap;overflow: hidden;">{{video['ci']}}</div> -->
            <div class="shop2_wenzi" :style="{'margin-top':vwidth*0.75+'px','width':vwidth+'px','height':vwidth*0.25+'px','line-height':vwidth*0.25+'px'}" style="white-space: nowrap;overflow: hidden;">{{video['ci']}}</div>
          </div>

        </div>
       </div>




     </div>
    <div style="position: absolute;top: 0;z-index: 1005;background-color: #000;z-index: 1005;" v-if="vshow" :style="{'width':screenHeight+'px','height':screenHeight+'px','left':(screenWidth-screenHeight)/2+'px'}">
      <video width="100%" height="98%" ref="videoPlayer" controls controlslist="nodownload noplaybackrate" disablePictureInPicture="true" id="myVideo">
        <source :src="video_url" type="video/mp4">

      </video>
      <div style="position: absolute;right:-2%;top:2px;" @click="close()"><i class="el-icon-circle-close" style="font-size: 25px;color: #ffffff;"></i></div>
    </div>

    <div class="beian1">
     <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank" style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>


    </div>

   </el-container>







</template>


<script>

  export default {
    data() {
      return {
        cshow:false,
        cshow1:false,
        cshow2:false,
        cshow3:false,
        vshow:false,
        list:[],
        shopk:[],
        shopkb:[],
        ishow:true,
        videos:[],
        video_url:'https://video.universepower.cn/yuzhouzhimi/2.mp4',
        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,
        vwidth:(window.innerWidth-40)/20,
        vheight : window.innerHeight/200,
        index_url:'https://video.universepower.cn/yuzhouzhimi/universepower_hunshayuzhou_zhiyeren_jinshasha_video3.mp4',
        ishows:false,
        search:''
      };
    },
    mounted() {


      },
      beforeDestroy() {

      },
    created() {

      this.loadList()
      this.getScreen()



    },

	methods:{
    goHome() {

      this.$router.push('/shop');
    },
    restartVideo() {
      this.$refs.videoPlayer.currentTime = 0;
      this.$refs.videoPlayer.play();
    },
    opens(url){


      this.ishows = false
      this.index_url = ""
      setTimeout(() => {
        this.ishows = true
        this.index_url = url

        this.$nextTick(() => {
          if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer.play();
          }
        });
      }, 200);

    },
    getScreen() {
      if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i )){
        window.location.href='http://m.universe.top/shop1'

      }

    },
    shows(item,index){
      this.ishow = false;
      item['typed'] = 1;
      item['typec'] = 1;
      // item['typea'] = 1;
      this.$set(this.list,index,item);

      setTimeout(()=>{
        item['typec'] = 2;
        item['typea'] = 1;
        this.$set(this.list,index,item);
      },400);
      setTimeout(()=>{
        item['typea'] = 0;
        this.$set(this.list,index,item);
      },800);
    },
    shows1(item,index){
      this.ishow = true;
      item['typed'] = 0;
      item['typeb'] = 1;

      this.$set(this.list,index,item);

      setTimeout(()=>{
        item['typeb'] = 2;
        item['typea'] = 2;
        this.$set(this.list,index,item);
      },400);
      setTimeout(()=>{
        item['typea'] = 0;
        this.$set(this.list,index,item);
      },800);
    },
    startVideo() {
      var that = this
      if (this.interval2) {
        clearInterval(this.interval2);
        this.interval2 = null;
      }
      this.interval2 = setInterval(() => {

        that.list.forEach(function(item, index) {

          if(item['num']<item['nums']){
            item['num'] = item['num']+1;
            that.$set(that.list,index,item);
            // that.$set(that.list, index, {'id':item['id'],'img':item['img'],'name':item['name'],'url':item['url'],'num':item['num']+1,'nums':item['nums'],'typea':item['typea'],'typeb':item['typeb'],'typec':item['typec'],'typed':item['typed']});
          }else{
            if(item['typed'] == 0){
              item['typed'] = 1;
              item['typec'] = 1;

              item['num'] = 0;
              item['nums'] = item['numz'];


              that.$set(that.list,index,item);
              setTimeout(()=>{
                item['typec'] = 2;
                item['typea'] = 1;
                that.$set(that.list,index,item);
              },400);
              setTimeout(()=>{
                item['typea'] = 0;
                // if(item['cc'] == 1){
                //   var bk = item['tu'].length - 1
                //   if(item['bkey'] < bk){
                //     item['bkey'] = item['bkey'] + 1
                //   }else{
                //     item['bkey'] = 0
                //   }
                //   item['imgs'] = item['tus'][item['bkey']]
                //   var tt = Math.floor(Math.random() * item['imgs'].length)
                //   item['url'] = item['imgs'][tt]
                // }
                that.$set(that.list,index,item);
              },800);
            }else{
              item['typed'] = 0;
              item['typeb'] = 1;

              item['num'] = 0;
              item['nums'] = item['numt'];

              that.$set(that.list,index,item);

              setTimeout(()=>{
                item['typeb'] = 2;
                item['typea'] = 2;
                that.$set(that.list,index,item);
              },400);
              setTimeout(()=>{
                item['typea'] = 0;
                that.$set(that.list,index,item);
              },800);
            }

          }

        })

      }, 1000);

    },

    toPage(id){
      this.$router.push('/shop2?id='+id);
    },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.search,



      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/shopImgsList'
      })
      .then(res=>{
        this.list = res.data.list;
        this.shopk = res.data.shopk;
        this.shopkb = res.data.shopkb;
        var that = this
        this.list.forEach(function(item, index) {
           item['typed'] = 1;
           item['typec'] = 2;
           item['typeb'] = 2;
           item['typea'] = 0;
           item['cc'] = 1;
           var ks = Math.floor(Math.random() * (that.shopkb.length-1));
           item['bkg'] = that.shopkb[ks]['img'];

        })


        var num = (Math.floor(this.screenHeight/this.vwidth)+1)*20*6 - this.list.length

        for(let i=0;i<num;i++){
          // console.log(i)
          var tt = Math.floor(Math.random() * 15)+5
          var k = Math.floor(Math.random() * (this.shopk.length-1))
          var ks = Math.floor(Math.random() * (this.shopkb.length-1));
          this.list.push({'id':0,'ci':'【马上发布】','bkg':this.shopkb[ks]['img'],'url':this.shopk[k]['img'],'i_id':0,'imgs':[],'name':'无','num':0,'nums':tt,'numz':tt,'numt':tt,'typea':0,'typeb':2,'typec':2,'typed':0,'cc':0})
        }
        // console.log(this.list)
        this.startVideo()
        this.index_url = res.data.index_url;
        this.opens(this.index_url)

      })
      .catch(err=>{

      });
    },
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},



	}


  }
</script>

<style>
.shop2_wenzi{
	background-image: url("../../assets/image/wenzi.png");
	background-repeat: no-repeat;
	background-size:100% 100%;
	color: #0071a1;
  font-weight: 600;
  font-size: 80%;
  font-family:'hanyi75';
  opacity: 0.8;

}
.shop1_searcht{
	position: absolute;
	height: 40px;
	/* line-height: 42px; */
	width: 15%;
	min-width: 60px;
	max-width: 100px;
	font-size: 90%;
	color: #fff;
	z-index: 99999;
	top: 0;
	right: 0;
	text-align: center;
	letter-spacing: 5px;
	background-color: #6000ff;
	border: solid 1px #6000ff;
	border-radius: 40px;
	opacity: 0.8;
	font-family:'hanyi75';
}
.shop1_search{
	/* width: 300px; */
	z-index: 99999;
	height: 40px;
	position: absolute;
	background-color: #000000;
	border: solid 1px #282839;
	border-radius: 40px;
	top: 0.7%;
	/* line-height: 40px;
	color: #04ddc0;
	font-size: 14px; */
	background-image: url("../../assets/image/search.png");
	background-repeat: no-repeat;
	background-position: 10px center; /* 图标位置 */
	background-size: 20px 20px;
	padding-left: 40px;
	opacity: 0.7;
	padding-right: 20px;

}
.shop1_searchi{
	z-index: 99999;
	background-color: #000000;
	border: none;
	outline: none;
	color: #04ddc0;
	line-height: 40px;
	font-size: 14px;
}
.donghuap{
  display: flex;
  justify-content: center;
  /* flex-direction: column; */
  overflow-x: hidden;
  position: relative;
  text-align: center;
  border: 1px solid #BBBBBB;
}
.donghuai{
  display: flex;
  transform: translateX(200%);
  transition: transform 0.4s ease;
  justify-content: center;

}
.adonghua{
  visibility: hidden;
}
.ddonghua{
  transform: translateX(0);
}
.edonghua{
  display: flex;
  transform: translateX(-200%);
  transition: transform 0.6s ease;
  justify-content: center;
}
.el-dropdown-menu__item{
  color: #ffffff;
  font-weight: bold;
  font-family: guanwangdaohang;
}
.popper__arrow{
  display: none;
}

  .content{
  	background: #939AA0;
  	width: 100%;
  	height: 100%;
  }
  body {
  overflow-x:hidden;
  overflow-y:hidden;
  }
  .el-scrollbar__wrap{
    background-color: black;
  }
  .bordered-box{
     overflow-wrap: break-word;
     /* margin-left: 20px; */
  }

 .beian1 {
    position: fixed; /* 定位为固定位置，覆盖整个视窗 */
    color: #616161;
    /* top: 0; */
    left: 42%;
    /* right: 0; */
    bottom: 0;

    z-index: 1000; /* 确保蒙层在其他内容之上 */
  }




</style>



// WEBPACK FOOTER //
// src/components/main/shop1.vue